// At least 8 characters AND one special char AND one letter
export const PASSWORD_REGEX = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;
export const CREDIT_CARD_NUMBER_REGEX = /^(\d{4} ){3}\d{4}$/;
